import React, { useState, useEffect } from 'react';
import BlogModal from './BlogModal';
import { ADMIN_ID } from "./Constants";
import { useSidebar } from '../../SidebarContext';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';
import { decryptToken } from '../utils/getToken';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import OmsSpinnerData from '../Loader/Spinner';

const Blogs = () => {
    const [blogs, setBlogs] = useState([]);
    const [modalData, setModalData] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const token = decryptToken("accessToken") || ""
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    // const apiUrl = import.meta.env.VITE_API_URL;
    const [currentPage, setCurrentPage] = useState(1);
    const [load, setLoad] = useState(false);
    const rowsPerPage = 10;


    useEffect(() => {
        const fetchBlogs = async () => {
            setLoad(true);
            try {
                const [resAll, resAdmin] = await Promise.all([
                    fetch(`http://localhost:8000/api/blogs`, {
                        method: "GET",
                        headers: {
                            "Authorization": `Bearer ${token}`
                        }
                    }),
                    fetch(`http://localhost:8000/api/blogs?AdminId=${ADMIN_ID}`, {
                        method: "GET",
                        headers: {
                            "Authorization": `Bearer ${token}`
                        }
                    })
                ]);

                const allBlogs = await resAll.json();
                const adminBlogs = await resAdmin.json();

                const allIds = new Set(allBlogs.map(b => b.id));
                const merged = [...allBlogs, ...adminBlogs.filter(ab => !allIds.has(ab.id))];

                setBlogs(merged);
            } catch (err) {
                console.error("❌ Failed to fetch blogs:", err);
            } finally {
                setLoad(false); // runs for success + error
            }
        };

        fetchBlogs();
    }, []);



    const handleSearch = (e) => setSearchQuery(e.target.value);

    const filteredBlogs = blogs.filter((blog) =>
        Object.values(blog).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    // Use blogs instead of testimonialData
    const totalPages = Math.ceil(filteredBlogs.length / rowsPerPage);

    const paginatedData = filteredBlogs.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePageChange = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const handleDelete = async (index) => {
        const blog = filteredBlogs[index];
        try {
            const res = await fetch(`http://localhost:8000/api/blogs/${blog.id}`, {
                method: "DELETE",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            if (res.ok) {
                setBlogs(prev => prev.filter(b => b.id !== blog.id));
            }
        } catch (err) {
            console.error("❌ Delete failed:", err);
        }
    };

    const handleEditClick = (blog) => {
        setModalData(blog);
        setIsModalOpen(true);
    };

    const handleModalSubmit = (newOrUpdatedBlog) => {
        if (modalData) {
            setBlogs(prev =>
                prev.map(blog => blog.id === newOrUpdatedBlog.id ? newOrUpdatedBlog : blog)
            );
        } else {
            setBlogs(prev => [newOrUpdatedBlog, ...prev]);
        }
        setModalData(null);
    };

    if (load) {
        return (
            <OmsSpinnerData />
        );
    }
    const getImageUrl = (path) => (path ? `http://localhost:8000/${path}` : '');

    return (
        <>
            <div className="oms-header">
                <h1 className="dashboard-title">Blogs</h1>
                <button
                    className="oms-add-btn"
                    onClick={() => {
                        setModalData(null);
                        setIsModalOpen(true);
                    }}
                >
                    Add Blog
                </button>

            </div>

            <div className="customer-table">
                <table>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Title</th>
                            <th>Image 1</th>
                            <th>Description</th>
                            <th>Image 2</th>
                            <th>CTA Type</th>
                            <th>CTA Value</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginatedData.length > 0 ? (
                            paginatedData.map((blog, index) => (
                                <tr key={blog.id}>
                                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                                    <td style={{ maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{blog.title}</td>
                                    <td>
                                        {blog.image1 && (
                                            <img
                                                src={getImageUrl(blog.image1)}
                                                alt="img1"
                                                className='w-12 h-12 rounded-full object-cover'
                                            />
                                        )}
                                    </td>
                                    <td style={{ maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                        {Array.isArray(blog.description)
                                            ? blog.description.join(", ")
                                            : blog.description}
                                    </td>
                                    <td>
                                        {blog.image2 && (
                                            <img
                                                src={getImageUrl(blog.image2)}
                                                alt="img2"
                                                className='w-12 h-12 rounded-full object-cover'
                                            />
                                        )}
                                    </td>
                                    <td>{blog.actionType === "link" ? "Visit" : "Call"}</td>
                                    <td style={{ maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                        {blog.actionValue}
                                    </td>

                                    <td>
                                        <button
                                            className="edit-button"
                                            onClick={() => handleEditClick(blog)}
                                        >
                                            <i className="fa-solid fa-pencil edit-oms"></i>
                                        </button>

                                        <button
                                            className="delete-button"
                                            onClick={() => handleDelete(index)}
                                        >
                                            <i className="fa-solid fa-trash delete-oms"></i>
                                        </button>
                                    </td>

                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8" style={{ textAlign: 'center' }}>
                                    No blog data found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
                <div className="pagination">
                    <button
                        onClick={() => handlePageChange(1)}
                        disabled={currentPage === 1}
                        className="pagination-chev-btn"
                    >
                        <ChevronsLeft size={18} />
                    </button>
                    <button
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="pagination-chev-btn"
                    >
                        <ChevronLeft size={18} />
                    </button>
                    <button className="pagination-btn active">{currentPage}</button>
                    <button
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="pagination-chev-btn"
                    >
                        <ChevronRight size={18} />
                    </button>
                    <button
                        onClick={() => handlePageChange(totalPages)}
                        disabled={currentPage === totalPages}
                        className="pagination-chev-btn"
                    >
                        <ChevronsRight size={18} />
                    </button>
                </div>
            )}

            <BlogModal
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                initialData={modalData}
                onSubmit={handleModalSubmit}
            />
        </>
    );
};

export default Blogs;
